export const base32 = (value) => value.toString(32).toUpperCase();

export const pluralize = (value) => (value.charAt(value.length - 1) === 's' ? value : `${value}s`);

const truncateUsername = (value, limit) => {
  const username = value || '';
  if (username.length >= limit) {
    return `${username.substr(0, limit)}...`;
  }
  return username;
};

export const usernameDisplay = (value) => truncateUsername(value, 14);

export const usernameDisplayLong = (value) => truncateUsername(value, 20);

export const ordinal = (value) => {
  const symbols = ['th', 'st', 'nd', 'rd'];
  const v = value % 100;
  const suffix = symbols[(v - 20) % 10] || symbols[v] || symbols[0];
  return `${value}${suffix}`;
};
